<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
    @on-close="handleMsgBoxClose"
  >
    <p slot="header">
      <span class="model-header">组队邀请</span>
    </p>
    <div>
      <div class="team-name">
        {{ teamInfo.team_name }}
        战队队长
        <span>{{ captainInfo.emp_name || '-' }}</span>
        邀请你加入队伍
      </div>
      <h-description :column="1">
        <h-description-item label="当前队员" :contextWrap="false">
          <span
            class="team-items"
            v-if="teamInfo.team_members && teamInfo.team_members.length !== 0"
          >
            <h-tooltip
              class="mate-item"
              placement="top"
              v-for="(item, index) in teamInfo.team_members"
              :key="item.emp_name"
            >
              <span :class="['mate-name', 'mate-' + index]">
                <span class="captain-tag" v-if="item.captain"
                  ><span>队长</span></span
                >
                {{ item.emp_name.substr(-2) }}</span
              >
              <div slot="content">
                <p style="color: #fff">{{ item.emp_name }}</p>
                <p style="color: #fff">{{ item.emp_id }}</p>
                <p style="color: #fff">{{ item.emp_post }}</p>
              </div>
            </h-tooltip>
          </span>
        </h-description-item>
      </h-description>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="confirmInviteJoin"
        >确认加入</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import { HDescription, HDescriptionItem } from '@/components/HDescription'
import Api from '@/api/competition/financialIndex'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TeamInvite',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton,
    HDescription,
    HDescriptionItem
  },
  computed: {
    ...mapGetters(['competeUser', 'captainInfo', 'teamInfo'])
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    handleMsgBoxClose() {
      this.$emit('stateChange', '')
    },
    confirmInviteJoin() {
      // 已登录
      if (Api.isUserLogined()) {
        // 已经填写过信息的情况下，直接加入队伍即可
        if (this.competeUser && this.competeUser.emp_name) {
          this.procJoinInviteTeam()
        } else {
          // 个人信息未填写，先补充个人信息
          this.$emit('stateChange', 'joinTeam')
        }
      } else {
        // 用户没有登录，先登录
        this.$emit('stateChange', '')
        this.$hMsgBox.confirm({
          title: '',
          content: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$goLoginUrl()
          },
          onCancel: () => {
            this.showModal = false
          }
        })
      }
    },
    procJoinInviteTeam() {
      Api.addCompetTeam(this.$route.query.teamId).then(
        ({ error_code, error_info }) => {
          if (error_code === '0') {
            // 获取队伍信息
            this.GetBeInviteTeam(this.$route.query.teamId).then((res) => {
              this.$emit('stateChange', 'joinInviteTeam', 'success')
            })
            this.GetCompeteUser() // 更新参赛信息
          } else {
            if (error_info.indexOf('满员') > -1) {
              // 获取队伍信息
              this.GetBeInviteTeam(this.$route.query.teamId).then((res) => {
                this.$emit('stateChange', 'joinInviteTeam', 'fail')
              })
            } else {
              this.$hMessage.error(error_info)
            }
          }
          // 去掉地址上面的teamId
          history.replaceState(
            null,
            null,
            window.location.href
              .replace(/(\?).*(?=#)/, '')
              .replace(/(\?)teamId=([^&#]*)([&#]|$)/, '')
              .replace(/(&)teamId=([^&#]*)([&#]|$)/, '')
          )
        }
      )
    },
    ...mapActions(['GetBeInviteTeam', 'GetCompeteUser'])
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.team-items {
  .mate-item {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    position: relative;
    margin-right: 10px;
    margin-top: 5px;
    .mate-name {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      white-space: nowrap;
      // overflow: hidden;
      text-overflow: ellipsis;
      &.mate-0 {
        background: #3060ff;
      }
      &.mate-1 {
        background: #1cb77b;
      }
      &.mate-2 {
        background: #ff791a;
      }
      &.mate-3 {
        background: #006600;
      }
      &.mate-4 {
        background: #993399;
      }
    }
    .captain-tag {
      position: absolute;
      width: 24px;
      height: 24px;
      background: url('~@/assets/financialCompetition/captain_bg.png')
        center/contain no-repeat;
      right: -4px;
      top: -9px;
      font-size: 12px;
      color: #fff;
      font-weight: 400;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        transform-origin: center;
        transform: scale(0.5);
      }
    }
  }
}
.team-name {
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #333333;
  text-align: left;
  line-height: 32px;
  margin: 0 0 24px 80px;
  span {
    color: #f2b044;
  }
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamInvite/TeamInvite.vue